//(function () {
//	'use strict';

//    const module = angular.module('imApp');

//    module.component('selectGlyphicon', {
//        templateUrl: 'views/components/views/selectGlyphicon/selectGlyphicon.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['utilityService', 'selectGlyphiconService', 'skillsCertificateTypeService', 'rememberService', function (utilityService, selectGlyphiconService, skillsCertificateTypeService, rememberService) {

//    		// #region VARIABLES & DEFINITIONS

//            const vm = this;
            
//    		vm.model = {
//                filterValueButtons: [
//                    { id: 'erase', icon: 'fa fa-solid fa-eraser', color: 'danger', type: 'danger', onClick: () => vm.model.setting.filtervalue = '' }
//                ],
//    			setting: {},
//    			itemsListGlyphicons: []
//    		};

//            // #endregion VARIABLES & DEFINITIONS

//    		// #region LOAD PROCEDURE CALLS

//            async function loadSetting() {
//                vm.model.setting = (await selectGlyphiconService.getSetting())[0];
//            }
            
//            async function loadGlyphicons() {
//                vm.model.itemsListGlyphicons = await skillsCertificateTypeService.listGlyphicons();
//            }

//            // #endregion LOAD PROCEDURE CALLS

//    		// #region REMEMBER VALUE FUNCTION
            
//    		vm.goToPrevious = function (item) {
//    			var variableName = 'w_selectglyphicon.selected_glyphicon';
                
//                if (utilityService.validateParmsValue(item.item_id) !== true) return;
                
//                rememberService.remember(variableName, item.item_id);
//            }

//            // #endregion REMEMBER VALUE FUNCTION

//            // #region ON INIT FUNCTION

//            vm.$onInit = function () {
//                loadSetting();
//                loadGlyphicons();
//            }

//            // #endregion ON INIT FUNCTION

//    	}]
//    });
//})();
